import { Row } from 'react-bootstrap';
import Styles from './contact.module.scss';
import { ContactUsMain } from './contactUsSection/contactUs';
import { Footer } from '../footer';
import { Navbar } from '../navbar';


function Contact() {
	return (
		<div >
			
			<Row>
			<Navbar />
			< ContactUsMain />
			< Footer />
			</Row>
			
			
		</div>
	);
}

export { Contact };
